const Card = {
	MuiCard: {
		styleOverrides: {
			root: {
				borderRadius: '8px',
			},
		},
	},
	MuiCardContent: {
		styleOverrides: {
			root: {
				padding: '24px 32px 16px',
			},
		},
	},
	MuiCardActions: {
		styleOverrides: {
			root: {
				padding: '0 32px 32px',
				'&>:not(:first-of-type)': {
					marginLeft: 24,
				},
			},
		},
	},
}

export default Card
